import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@/redux/store';
import logoSrc from '@/assets/images/logo.png';

interface LogoProps {
    className?: string;
    alt?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "w-[150px] h-auto", alt = "Logo" }) => {
    const organisation = useSelector((state: RootState) => state.organisation.organisation);
    
    // Use organisation logo if available, otherwise fall back to default logo
    const logoSrcToUse = organisation?.logoUrl || logoSrc;
    
    return (
        <img 
            className={className} 
            src={logoSrcToUse} 
            alt={alt}
            onError={(e) => {
                // Fallback to default logo if organisation logo fails to load
                const target = e.target as HTMLImageElement;
                if (target.src !== logoSrc) {
                    target.src = logoSrc;
                }
            }}
        />
    );
};

export default Logo;
